export default {"src":"/_next/static/media/mainLogo.53cbd686.svg","height":50,"width":50};